export const getAnsweredInboxCount = state => state.processStatement.answeredInboxCount;